<header>
  <nav class="navbar navbar-expand-lg navbar-dark bg-white px-3 border-bottom shadow-sm py-1 fixed-top">
    <!--    <nav class="navbar navbar-expand-lg fixed-top portfolio-navbar gradient navbar-dark px-3">-->

    <a class="navbar-brand align-text-bottom text-dark" routerLink="/">
      <span class="pr-1"><img src="resumir_logo_big.png" alt="Logo" class="logo logo-nav"></span>
      resumir.<span class="fw-bold text-primary">ai</span> <span class="d-none text-secondary small fst-italic"> {{ page }}</span></a>

    <div class="d-lg-none w-md-auto py-1 center">
      <div type="button" class="btn btn-primary rounded-5 btn-sm w-md-auto px-3" routerLink="/plans" (click)="closeDropdown()"><span class=" me-2" style="width: 3em;">👑</span> {{ 'PLANS_AND_PRICING' | translate }}</div>
    </div>

    <!--    Dropdown menu -->
    <div class="menu-toggle-wrapper d-flex flex-column align-items-center py-0">
      <button
        class="navbar-toggler mb-0 pb-0"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <span class="menu-label small mt-0 d-lg-none">Menu</span>
    </div>

    <!--    Menu -->
    <div class="collapse navbar-collapse " id="navbarNav">
      <ul class="navbar-nav ms-md-auto w-md-auto text-center d-flex flex-column flex-md-row align-items-center gap-0 gap-md-2">
        <li class="small w-md-auto py-2" [hidden]="plan === ''">
          <div class="small w-md-auto px-3 fw-light text-dark">⭐ {{ credits }}</div>
        </li>
        <!--        <li class="nav-item  w-md-auto py-2" [hidden]="plan === ''">-->
        <!--          <div class="small w-md-auto px-3 fw-light" >{{ plan }}</div>-->
        <!--        </li>-->
        <li class="nav-item  w-md-auto py-1 d-lg-none">

          <!--          FIX DYNAMISCH -->

          <div type="button" class="btn btn-link btn-sm no-underline rounded-5 w-lg-auto" routerLink="/" (click)="closeDropdown()"><span class=" me-2" style="width: 3em;">📝</span> Summarizer</div>
        </li>
        <li class="nav-item  w-md-auto py-1 d-lg-none">

          <!--          FIX DYNAMISCH -->

          <div type="button" class="btn btn-link btn-sm text-danger no-underline rounded-5 w-lg-auto" routerLink="/solver" (click)="closeDropdown()"><span class=" me-2" style="width: 3em;">💡</span> Solver</div>
        </li>

        <li class="d-none d-lg-block nav-item  w-md-auto py-1">
          <div type="button" class="btn btn-primary rounded-5 btn-sm w-md-auto px-3" routerLink="/plans" (click)="closeDropdown()"><span class=" me-2" style="width: 3em;">👑</span> {{ 'PLANS_AND_PRICING' | translate }}</div>
        </li>
        <li class="nav-item w-md-auto py-1">
          <button type="button" class="btn btn-secondary rounded-5 btn-sm w-md-auto px-3" data-bs-toggle="modal" data-bs-target="#exampleModal" (click)="fixSignIn()" [hidden]="token">{{ 'SIGN_IN_1' | translate }}</button>
        </li>
        <li class="nav-item w-md-auto py-1">
          <button type="button" class="btn btn-sm w-md-auto rounded-5" (click)="logout()" [hidden]="!token">{{ 'LOG_OUT' | translate }}</button>
        </li>
      </ul>
    </div>


  </nav>
  <!-- Modal -->
  <div class="modal fade"  #signInModal id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <app-signin (plan)="getPlanAndCredits()" (tokenChange)="tokenChange()"></app-signin>
  </div>
</header>
